import { ListResult } from '@shared/api';
import { Api } from '../../Api';
import { IServiceAccountBalance } from './interfaces';
import { IServiceAccountBalanceGetQuery, IServiceAccountBalanceGetTotalQuery } from './query';

export class AccountBalance {
    private static _basePath = '/AccountBalance';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${AccountBalance._basePath}`;
        return {
            async get(query: IServiceAccountBalanceGetQuery) {
                const path = '/';
                return await Api.get<ListResult<IServiceAccountBalance>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getTotal(query: IServiceAccountBalanceGetTotalQuery) {
                const path = '/total';
                return await Api.get<number>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
        };
    }
}
